import React from 'react';
import { Form, InputNumber } from 'antd';

const EngineCapacity = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <div className="powerEngineArea">
      <span className="label">Мощность, л.с.:</span>
      <Form.Item>
        {getFieldDecorator('engineCapacity')(
          <InputNumber
            className="smallInput"
            min={49}
            max={999}
            maxLength={3}
            placeholder="Укажите"
            disabled={disabled}
          />
        )}
      </Form.Item>
    </div>
  );
};

export default EngineCapacity;
